import axios from 'axios';
import moment from 'moment';

import MitPeopleService from './MitPeopleService.js';
import BaseMitDateTimeService from './BaseMitDateTimeService.js';

class MitRequestApprovalService {
    constructor() {
        this.BaseMitDateTimeService = new BaseMitDateTimeService();
        this.tempRequests = [];
        this.REQUEST_STATES = {
            NEW:{
                val:'new',
                name:'New',
                color:'grey lighten-3',
                // color:'blue-grey lighten-3',
                // outlined:true,
                hint:''
            },
            IN_PROGRESS:{
                val:'progress',
                name:'In Progress',
                // color:'amber lighten-3',
                color:'blue lighten-4',
                hint:''
            },
            COMPLETED:{
                val:'completed',
                name:'Completed',
                color:'green lighten-4',
                // color:'primary',
                hint:''
            },
            CLOSED:{
                val:'closed',
                name:'Closed',
                color:'primary',
                hint:''
            },
        }
        this.REQUEST_TYPES = {
            ADD_PERSON:{
                val:'add_person',
                name:'Add Person',
                color:'primary',
                icon:'mdi-account-plus',
                hint:''
            },
            UPDATE_PERSON:{
                val:'update_person',
                name:'Update Person',
                color:'amber',
                icon:'mdi-account-edit',
                hint:''
            },
            REMOVE_PERSON:{
                val:'remove_person',
                name:'Remove Person',
                color:'red darken-4',
                icon:'mdi-account-remove',
                hint:''
            }
        }
       
        //TEMP CODE
        this.tempRequests.push(
            this.newRequest(
                { id:this.tempRequests.length+1, requestType:this.REQUEST_TYPES.ADD_PERSON, description:'Please add Andy Bernard, we would like to make an offer.', createdBy:{csailId:'mscott', fullName:'Michael Scott'}, owner:{csailId:'tflenderson', fullName:'Toby Flenderson'}},
                { info:{fname:'Andy', lname:'Bernard'} }
            )
        );
        this.tempRequests.push(
            this.newRequest(
                { id:this.tempRequests.length+1,  requestType:this.REQUEST_TYPES.ADD_PERSON, description:'Need Meredith Palmer, she will start sooon.', createdBy:{csailId:'tflenderson', fullName:'Toby Flenderson'}, owner:{csailId:'tflenderson', fullName:'Toby Flenderson'}},
                { info:{fname:'Meredith', lname:'Palmer'} }
            )
        );
        this.tempRequests.push(
            this.newRequest(
                { id:this.tempRequests.length+1,  requestType:this.REQUEST_TYPES.ADD_PERSON, state:this.REQUEST_STATES.IN_PROGRESS, description:'Add Kevin Malone, he will not start until 2025.', createdBy:{csailId:'mscott', fullName:'Michael Scott'}, owner:{csailId:'tflenderson', fullName:'Toby Flenderson'}},
                { info:{fname:'Kevin', lname:'Malone'} }
            )
        );
        this.tempRequests.push(
            this.newRequest(
                { id:this.tempRequests.length+1,  requestType:this.REQUEST_TYPES.UPDATE_PERSON, state:this.REQUEST_STATES.IN_PROGRESS, description:'Edit Oscar Martinez, his appointment is changing this year due to new position.', createdBy:{csailId:'mscott', fullName:'Michael Scott'}, owner:{csailId:'tflenderson', fullName:'Toby Flenderson'}},
                { info:{fname:'Oscar', lname:'Martinez'} }
            )
        );
        this.tempRequests.push(
            this.newRequest(
                { id:this.tempRequests.length+1, requestType:this.REQUEST_TYPES.REMOVE_PERSON, state:this.REQUEST_STATES.COMPLETED, description:'Remove Roy Anderson, he has resigned his position.', createdBy:{csailId:'mscott', fullName:'Michael Scott'}, owner:{csailId:null, fullName:null}},
                { info:{fname:'Roy', lname:'Anderson'} }
            )
        );
    }

    getStateDict() {
        return this.REQUEST_STATES;
    }
    
    getStateArray(){
        let a = [];
        for (var key in this.REQUEST_STATES) {
            if (this.REQUEST_STATES.hasOwnProperty(key)) {
                a.push(this.REQUEST_STATES[key])
            }
        }
        return a;
    }

    getTypesArray(){
        let a = [];
        for (var key in this.REQUEST_TYPES) {
            if (this.REQUEST_TYPES.hasOwnProperty(key)) {
                a.push(this.REQUEST_TYPES[key])
            }
        }
        return a;
    }

    newRequest(request, person){
        request = request || {};
        request.owner = request.owner || {}
        request.comments = request.comments || []

        if(request.owner.csailId === null){
            request.owner = {csailId:null, fullName:'(none)'}
        }
        let comments = [];
        for(let x = 0; x < request.comments.length; x++){
            comments.push({
                text:request.comments[x].text,
                user:{csailId:request.comments[x].user.csailId, fullName:request.comments[x].user.fullName}
            })
        }
        request.comments = comments;

        return {
            id: request.id || 0,
            description: request.description || '',
            comments: request.comments,
            owner: {csailId:request.owner.csailId, fullName:request.owner.fullName},
            state: request.state || this.REQUEST_STATES.NEW,
            person:MitPeopleService.createPersonModel(person),
            requestType:request.requestType || this.REQUEST_TYPES.ADD_PERSON,
            createdBy: request.createdBy || {csailId:null, fullName:null},
            createDt: request.createDt || this.BaseMitDateTimeService.getDateNow(),
            lastEditDt:request.lastEditDt || this.BaseMitDateTimeService.getDateNow()
        };
    }

    getActions(){
        return new Promise ((resolve, reject) => {
            return resolve( [this.newRequest(
                    { id:this.tempRequests.length+1, requestType:this.REQUEST_TYPES.ADD_PERSON, description:'Please add Andy Bernard, we would like to make an offer.', createdBy:{csailId:'mscott', fullName:'Michael Scott'}, owner:{csailId:'tflenderson', fullName:'Toby Flenderson'}},
                    { info:{fname:'Andy', lname:'Bernard'},state:MitPeopleService.getStateDict().IN_PROGRESS_WAITING_APPROVAL },
                )]
            )
                //return reject(error);
        });
    }

    getRequests(){
        return new Promise ((resolve, reject) => {
                return resolve(this.tempRequests);
                //return reject(error);
        });
    }

    saveRequest(request){
        return new Promise ((resolve, reject) => {
            //TEMP CODE
                request.id = this.tempRequests.length+1;
                request.createDt = this.BaseMitDateTimeService.getDateStringNowLocal();
                request.createdBy = 'me';
            //END TEMP CODE
            this.tempRequests.push(request);
            return resolve(true);
                //return reject(error);
        });
    }

}

export default new MitRequestApprovalService();
